import { Suspense, lazy } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import AddEditFaq from "../pages/cms/FaqManagement/AddEditFaq";
import FaqList from "../pages/cms/FaqManagement/List";
import AddEditEmailTemplate from "../pages/EmailTemplate/AddEditEmailTemplate";
import EmailTemplateList from "../pages/EmailTemplate/List";
import ViewEmailDetail from "../pages/EmailTemplate/ViewEmail";
import GlobalSetting from "../pages/Global Setting";
import AddEditUserManagement from "../pages/UserManagement/AddEditUser";
import UserManagementList from "../pages/UserManagement/List";
import ViewUserManagement from "../pages/UserManagement/ViewUser";
import LotteryTicketsManagement from "../pages/LotteryTicketsManagement/List";
import ViewLotteryTickets from "../pages/LotteryTicketsManagement/ViewUser";
import AddEditLotteryTickets from "../pages/LotteryTicketsManagement/AddEditTicket";
import ResultUpload from "../pages/LotteryTicketsManagement/resultUpload";
import EditLotteryLicence from "../pages/LotteryLicenseManagement";
import WalletManagementList from "../pages/WalletManagement/List";
import AllTrangectionList from "../pages/WalletManagement/AllTrangectionList";
import ViewTransactionDetail from "../pages/WalletManagement/ViewTransactionDetail";
import NotificationTemplateList from "../pages/Notificationmanagement/NotificationTemplate/List";
import ListNotification from "../pages/Notificationmanagement";
import EditNotification from "../pages/Notificationmanagement/NotificationTemplate/EditNotification";
import PaymentManagement from "../pages/PaymentManagement";

const CmsPage = lazy(() => import("../pages/cms/CmsPage"));
const ViewCms = lazy(() => import("../pages/cms/ViewCms"));
const AddEditCms = lazy(() => import("../pages/cms/AddEditCms"));
const MyAccount = lazy(() => import("../pages/myAccount/MyAccount"));
const PrivateLayout = lazy(() => import("../layouts/private"));
const Page404 = lazy(() => import("../pages/error/Page404"));
const DashboardPage = lazy(() => import("../pages/dashboard/DashboardPage"));
const LoadingFallback = <div>Loading...</div>;

const makeLazyComponent = (importFunc) => (
  <Suspense fallback={LoadingFallback}>{importFunc()}</Suspense>
);

const MainRouting = () => {
  const routes = [
    {
      element: <PrivateLayout />,
      errorElement: <Page404 />,
      children: [
        { element: <Navigate to="/dashboard" />, index: true },
        {
          path: "dashboard",
          element: makeLazyComponent(() => <DashboardPage />),
        },
        {
          path: "profile",
          element: makeLazyComponent(() => <MyAccount />),
        },
        {
          path: "global-setting",
          element: makeLazyComponent(() => <GlobalSetting />),
        },
        {
          path: "user-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <UserManagementList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditUserManagement />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditUserManagement />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewUserManagement />),
            },
          ],
        },

        {
          path: "lottery-license-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <EditLotteryLicence />),
            },
          ],
        },

        {
          path: "wallet-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <WalletManagementList />),
            },
            {
              path: "transaction-history/:id",
              element: makeLazyComponent(() => <AllTrangectionList />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewTransactionDetail />),
            },

          ],
        },
        {
          path: "tickets-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <LotteryTicketsManagement />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditLotteryTickets />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditLotteryTickets />),
            },
            {
              path: "result-upload/:id",
              element: makeLazyComponent(() => <ResultUpload />),
            },
          ],
        },


        {
          path: "notification-setting",
          children: [
            { index: true, element: makeLazyComponent(() => <ListNotification />) },
          ]
        },
        {
          path: "notification-management",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <NotificationTemplateList />),
            },
            {
              path: "edit/:id",
              element: makeLazyComponent(() => <EditNotification />),
            },
          ],
        },

        {
          path: "payment-management",
          children: [
            { index: true, element: makeLazyComponent(() => <PaymentManagement />) },
          ]
        },


        {
          path: "email-template",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <EmailTemplateList />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditEmailTemplate />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditEmailTemplate />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewEmailDetail />),
            },
          ],
        },

        {
          path: "cms",
          children: [
            {
              index: true,
              element: makeLazyComponent(() => <CmsPage />),
            },
            {
              path: "add",
              element: makeLazyComponent(() => <AddEditCms />),
            },

            {
              path: "edit/:id",
              element: makeLazyComponent(() => <AddEditCms />),
            },
            {
              path: "view/:id",
              element: makeLazyComponent(() => <ViewCms />),
            },

          ],
        },
        {
          path: "faq",
          children: [
            { index: true, element: makeLazyComponent(() => <FaqList />) },
            { path: "add", element: makeLazyComponent(() => <AddEditFaq />) },
            { path: "edit/:id", element: makeLazyComponent(() => <AddEditFaq />) },
          ]
        },
      ],
    },
    { path: "*", element: <Navigate to="/dashboard" /> },
  ];

  return useRoutes(routes);
};

export default MainRouting;